import React from 'react';
import { statusColor, statusLabel } from '../lib/loadStatus';

export const LoadStatusPill = ({ status, size = 'sm', testId, className = '' }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center rounded font-semibold whitespace-nowrap ${size === 'xs' ? 'px-2 py-0.5 text-[10px] uppercase tracking-wider' : 'px-2 py-1 text-xs'} ${statusColor(status)} ${className}`}
  >
    {statusLabel(status)}
  </span>
);

export default LoadStatusPill;
